/* eslint-disable camelcase */
import { PlusOutlined } from '@ant-design/icons';
import { Col, Row, Tabs, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { InputAdornment } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import Chip from '@mui/material/Chip';
import ChipInput from 'material-ui-chip-input';
import 'react-quill/dist/quill.snow.css';
import SelectExisting from './SelectExisting';
import FileElement from './contentFields/FileElement';
// eslint-disable-next-line import/extensions
import ContentModel from './contentFields/ContentModel.tsx';
import mediaIcon from '../../asset/media.svg';
import richTextIcon from '../../asset/richtext.svg';
import textIcon from '../../asset/text.svg';
import CButton from '../../component/Button';
import CustomDatePicker from '../../component/DatePicker';
import dateIcon from '../../component/DatePicker/Date.svg';
import FieldElement from '../../component/FieldElement';
import { CStandardInput, CStandardTextfield } from '../../component/Input';
import Modal from '../../component/Modal/Modal';
import CReactQuill from '../../component/Quill/ReactQuill';
import { AutocompleteSelect } from '../../component/Select';
import { getContents, getCustomTypeById, uploadBannerImage } from '../../services/napi';
import './contentDetail.css';
import { isCurrentProjectGulfMap } from 'src/util/projectCheckers';

const { TabPane } = Tabs;
const useStyles = makeStyles({
  root: {
    ' & .MuiInputBase-root': {
      background: '#F0F4FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px 40px 0px 35px',
      padding: '14px 16px'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    }
  }
});

const datePickerStyle = {
  display: 'flex',
  justifyContent: 'start',
  padding: '0 35px',
  width: '100%'
};

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function selectExisting(onClick) {
  return (
    <CButton onClick={onClick} size="large" type="edit">
      Select Existing
    </CButton>
  );
}

const TextElement = ({ value, characterLimit, isDisabledLimit, onChange = () => {} }) => {
  const classes = useStyles();
  const [inputTextLength, setInputTextLength] = useState(value.length);
  const rows = value && value.length ? value?.split('\n')?.length : 1;
  console.log(isDisabledLimit);

  return (
    <CStandardTextfield
      adornment={
        characterLimit ? (
          <InputAdornment
            position="end"
            style={
              characterLimit - inputTextLength === 0
                ? { color: 'red' }
                : { color: 'rgba(0, 0, 0, 0.85)' }
            }
          >
            {characterLimit - inputTextLength}
          </InputAdornment>
        ) : null
      }
      disabled={isDisabledLimit}
      disableUnderline
      formclasses={{ root: classes.root }}
      inputProps={{
        maxLength: characterLimit
      }}
      onChange={(e) => {
        onChange(e.target.value);
        setInputTextLength(e.target.value.length);
      }}
      rows={rows}
      value={value}
      width="true"
    />
  );
};

const DateElement = ({ value, onChange = () => {} }) => {
  return (
    <div style={datePickerStyle}>
      <CustomDatePicker onChange={onChange} value={value} />
    </div>
  );
};

const ChipsTextElement = ({ value = [], onChange = () => {} }) => {
  const [chips, setChips] = useState(Array.isArray(value) ? value : []);

  const handleAddChip = (chip) => {
    setChips((prev) => {
      const updatedChips = [...prev, chip];
      onChange([...prev, chip]);
      return updatedChips;
    });
  };

  const handleDeleteChip = (chip) => {
    setChips(() => {
      const filteredChips = chips.filter((item) => item !== chip);
      onChange(filteredChips);
      return filteredChips;
    });
  };

  return (
    <ChipInput
      allowDuplicates
      newChipKeys={['Enter', 'Tab']}
      onAdd={(chip) => handleAddChip(chip)}
      onDelete={(chip) => handleDeleteChip(chip)}
      placeholder="Enter tags"
      style={{ width: '95%' }}
      value={chips}
    />
  );
};

const RichTextElement = ({ value, onChange = () => {} }) => {
  return (
    <>
      <CReactQuill
        onChange={(content) => {
          onChange(content);
        }}
        style={{
          height: '300px',
          paddingLeft: '27px'
        }}
        value={value}
      />
    </>
  );
};

const ObjectElement = ({ field_addition, value, onChange = () => {} }) => {
  const classes = useStyles();
  const keys = Object.keys(field_addition);

  return (
    <div>
      {keys.map((key, index) => {
        return (
          <div key={index} style={{ marginBottom: '10px', textAlign: 'left' }}>
            <h4 style={{ fontSize: '12px', marginLeft: '38px' }}>{key}</h4>
            <CStandardInput
              disableUnderline
              formclasses={{ root: classes.root }}
              onChange={(e) => {
                onChange({
                  ...value,
                  [key]: e.target.value
                });
              }}
              value={value[key]}
              width="true"
            />
          </div>
        );
      })}
    </div>
  );
};

const ConnectToContentElement = ({ value, field_addition, onChange = () => {} }) => {
  const [contents, setContents] = useState([]);
  const [remainingContentsToSelect, setRemainingContentsToSelect] = useState([]);
  const currentProjectId = useSelector(({ project }) => project.currentProject._id);
  const { id: contentModelId } = field_addition;

  function selectContent(selectedContentInfo) {
    const selectedContent = contents.filter((content) => content.id === selectedContentInfo.id);
    onChange([...value, selectedContent[0]]);
  }

  function removeSelectedContent(contentId) {
    const filteredContents = value.filter((content) => content.id !== contentId);
    onChange([...filteredContents]);
  }

  useEffect(() => {
    async function fetchData() {
      const customTypeResponse = await getCustomTypeById(contentModelId, currentProjectId);
      if (!customTypeResponse) return;

      // Can't find non-paginated fetch, so we use 1000
      const contents = await getContents(currentProjectId, 1, 1000, '', contentModelId);

      if (contents.data?.content?.length) {
        contents.data?.content.forEach(async (content) => {
          const { name, _id: id } = content;
          setContents((oldData) => [...oldData, { id, name }]);
        });
      }
    }

    fetchData();
  }, [contentModelId]);

  useEffect(() => {
    const remainingContents = contents.filter((content) => {
      const isContentAlreadySelected = value?.some(
        (chosenContent) => chosenContent.id === content.id
      );
      const isDisplayed = !isContentAlreadySelected;
      return isDisplayed;
    });
    setRemainingContentsToSelect([...remainingContents]);
  }, [value, contents]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          margin: '0px auto 30px 35px',
          textAlign: 'start'
        }}
      >
        {value.map((content) => {
          return (
            <Chip
              key={content.id}
              label={content.name}
              onClick={() => {
                navigator.clipboard.writeText(content.name);
              }}
              onDelete={() => removeSelectedContent(content.id)}
            />
          );
        })}
      </div>

      <AutocompleteSelect
        getOptionLabel={(option) => option?.name}
        id="autocomplete-contentDetailBody-selectContents"
        onSelect={selectContent}
        options={remainingContentsToSelect}
        placeholderValue="Select Contents"
        styles={{
          margin: '0px auto 0px 35px',
          width: '300px'
        }}
      />
    </div>
  );
};

const SelecteElement = ({ value, field_addition, onChange = () => {} }) => {
  const { selectData } = field_addition;
  const [elements, setElements] = useState([]);
  const [remainingElementsToSelect, setRemainingElementsToSelect] = useState([]);

  function selectSingleElement(selectedElementInfo) {
    setElements(selectData);
    const selectedElement = elements.filter((element) => element === selectedElementInfo);
    onChange([...value, selectedElement[0]]);
  }

  function removeSelectedContent(removedElement) {
    const filteredElements = value.filter((element) => element !== removedElement);
    onChange([...filteredElements]);
    setElements(selectData);
  }

  useEffect(() => {
    setElements(selectData);
    const remainingElements = elements.filter((element) => {
      const isContentAlreadySelected = value?.some((chosenElement) => chosenElement === element);
      const isDisplayed = !isContentAlreadySelected;
      return isDisplayed;
    });
    setRemainingElementsToSelect([...remainingElements]);
  }, [value, elements]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          margin: '0px auto 30px 35px',
          textAlign: 'start'
        }}
      >
        {value.map((element, index) => {
          return (
            <Chip
              key={index}
              label={element}
              onClick={() => {
                navigator.clipboard.writeText(element);
              }}
              onDelete={() => removeSelectedContent(element)}
            />
          );
        })}
      </div>

      <AutocompleteSelect
        getOptionLabel={(option) => option}
        id="autocomplete-contentDetailBody-selectContents"
        onSelect={selectSingleElement}
        options={remainingElementsToSelect}
        placeholderValue="Select Contents"
        styles={{
          margin: '0px auto 0px 35px',
          width: '300px'
        }}
      />
    </div>
  );
};

const MediaElement = ({ index, value, ratio, onChange = () => {}, onSelectExisting }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [uploaded, setUploaded] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [uploadedSize, setUploadedSize] = useState(null);
  // const [uploadedSize, setUploadedSize] = useState(null);
  // const [uploadedRatio, setUploadedRatio] = useState(0);

  const [ratioWindow, setRatioWindow] = useState(false);

  const [fileList, setFileList] = useState([]);
  // const [compressedFile, setCompressedFile] = useState(null);

  useEffect(() => {
    if (value) {
      setFileList([
        {
          name: 'Preview',
          status: 'done',
          uid: index,
          url: value || ''
        }
      ]);
    }
  }, [value, index]);

  const projectId = useSelector(({ project }) => project.currentProject._id);

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const handleChange = ({ fileList }) => {
    if (fileList.length) {
      setUploadedSize(formatBytes(fileList[0].size));
      // setUploadedSize(formatBytes(fileList[0]['size']));
    }

    setFileList(fileList);

    if (!fileList.length) {
      onChange('');
    }
    setFileList([]);
  };

  const ratioLimiter = (file) => {
    // let result;
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', (event) => {
        const _loadedImageUrl = event.target.result;
        const image = document.createElement('img');
        image.src = _loadedImageUrl;
        image.addEventListener('load', () => {
          const { width, height } = image;

          resolve((width / height).toFixed(2));
        });
      });
    });
  };

  const uploadRequest = async (data) => {
    const formData = new FormData();
    formData.append('file', data.file);

    const res = await uploadBannerImage(formData, projectId);

    onChange(res.data.file.url);

    data.onSuccess();
  };

  const customRequest = async (data) => {
    const uploadedRatio = await ratioLimiter(data.file);

    if (ratio) {
      const { ratioWidth, ratioHeight } = ratio;
      const standardRatio = (ratioWidth / ratioHeight).toFixed(2);

      if (uploadedRatio === standardRatio) {
        uploadRequest(data);
      } else {
        setUploaded(data);
        setRatioWindow(true);
      }
    } else {
      uploadRequest(data);
    }
  };

  function formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        paddingLeft: '35px'
      }}
    >
      <Upload
        customRequest={customRequest}
        fileList={fileList}
        listType="picture-card"
        onChange={handleChange}
        onPreview={handlePreview}
      >
        {uploadButton}
      </Upload>

      <Modal
        footerActions={
          <>
            <CButton
              onClick={() => {
                // setUploadedSize(0);
                setRatioWindow(false);
              }}
              size="large"
              type="secondary"
            >
              Delete
            </CButton>
            <CButton
              onClick={() => {
                uploadRequest(uploaded);
                setRatioWindow(false);
              }}
              size="large"
              type="primary"
            >
              Add
            </CButton>
          </>
        }
        handleClose={() => setRatioWindow(false)}
        isModalOpen={ratioWindow}
        styles={{
          '& .MuiDialogActions-root': {
            justifyContent: 'center',
            paddingBottom: '24px'
          },
          '& .modal-title': {
            fontSize: '16px',
            fontWeight: 500
          }
        }}
        titleContent={<h2 className="modal-title">Aspect Ratio does not match</h2>}
      >
        <p
          style={{
            fontSize: '24px',
            fontWeight: 700
          }}
        >
          Delete uploaded image or Add?
        </p>
      </Modal>

      <div className="upload-div">{selectExisting(onSelectExisting())}</div>
      <Modal
        handleClose={handleCancel}
        isModalOpen={previewVisible}
        styles={{
          '& .MuiDialogContent-root': {
            paddingBottom: '24px',
            paddingTop: '0px'
          }
        }}
        titleContent={<h3 className="modal-title">{previewTitle}</h3>}
      >
        <img alt="example" src={previewImage} style={{ width: '100%' }} />
      </Modal>
    </div>
  );
};

const BluishCheckBox = withStyles({
  checked: {},
  root: {
    '&$checked': {
      color: '#6265f4'
    },
    color: '#6265f4'
  }
})((props) => <Checkbox color="default" {...props} />);

const CheckBoxElement = ({ label, value, onChange = () => {} }) => {
  return (
    <FormControlLabel
      control={
        <BluishCheckBox
          checked={value}
          defaultChecked
          onChange={(event) => {
            onChange(event.target.checked);
          }}
        />
      }
      label={label}
    />
  );
};

const ContentDetailForm = (props) => {
  const { content, onSelectExisting, lang, onGenericChange } = props;
  const activeLanguages = useSelector(({ language }) => language.activeLanguages);

  const fields = Object.keys(content.customType.template).map((key, index) => {
    const item = content.customType.template[key];
    item.name = key;

    return {
      field: item,
      index,
      key: index,
      order: item.order
    };
  });

  const keys = [];
  Object.keys(content.data).forEach((key) => {
    keys.push(key);
  });

  if (content.data.length !== activeLanguages.length) {
    const filterLanguages = activeLanguages.filter(
      (language) => keys.filter((key) => language.key === key).length === 0
    );
    let filterLanguagesKay;

    if (filterLanguages.length) {
      filterLanguagesKay = filterLanguages[0].key;
    }

    const emptyField = { ...content.data.en };

    Object.keys(emptyField).forEach((key) => {
      emptyField[key] = '';
    });
    content.data = { ...content.data, [filterLanguagesKay]: emptyField };
  }

  const data = content.data[lang];

  fields.sort((a, b) => a.order - b.order);

  return (
    <Row>
      <Col span={24}>
        {fields.map(({ field }, index) => {
          const { field_type, label, name } = field;
          const [entitiesCount, setEntitiesCount] = useState(undefined);

          switch (field_type) {
            case 'text':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={textIcon}
                  lang={lang}
                  name={name}
                  title={label}
                  type={field_type}
                >
                  <TextElement
                    characterLimit={
                      field.field_addition ? field.field_addition.characterLimit : null
                    }
                    isDisabledLimit={isCurrentProjectGulfMap && field.field_name === 'uniqueCode'}
                    lang={lang}
                    onChange={onGenericChange(name, lang)}
                    title={label}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'list':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={textIcon}
                  lang={lang}
                  name={name}
                  title={label}
                  type={field_type}
                >
                  <ChipsTextElement
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || []}
                  />
                </FieldElement>
              );
            case 'tinymce':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="rich text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={richTextIcon}
                  // justify="start"
                  margin="0px"
                  title={label}
                >
                  <RichTextElement
                    onChange={onGenericChange(name, lang)}
                    value={Array.isArray(data[name]) ? data[name].join('/') : data[name]}
                  />
                </FieldElement>
              );
            case 'file':
              return (
                <FieldElement
                  key={index}
                  alt="media icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={mediaIcon}
                  title={label}
                >
                  <MediaElement
                    index={index}
                    onChange={onGenericChange(name, lang)}
                    onSelectExisting={() => onSelectExisting(name, lang)}
                    ratio={field.field_addition}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'files':
              return (
                <FieldElement
                  key={index}
                  alt="media icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={mediaIcon}
                  title={label}
                >
                  <FileElement
                    index={index}
                    onChange={onGenericChange(name, lang)}
                    onSelectExisting={() => onSelectExisting(name, lang, false)}
                    ratio={field.field_addition}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'date':
              return (
                <FieldElement
                  key={index}
                  alt="date icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={dateIcon}
                  title={label}
                  type={field_type}
                >
                  <DateElement
                    index={index}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'checkbox':
              return (
                <FieldElement key={index} title={label}>
                  <CheckBoxElement
                    index={index}
                    label={label}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'complex list':
              return (
                <FieldElement
                  key={index}
                  alt="text icon"
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <ObjectElement
                    field_addition={field.field_addition ? field.field_addition : {}}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'Connect To Content':
              return (
                <FieldElement
                  key={index}
                  alt="text icon"
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <ConnectToContentElement
                    field_addition={field.field_addition ? field.field_addition : {}}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || []}
                  />
                </FieldElement>
              );

            case 'Content Model':
              return (
                <FieldElement
                  key={index}
                  // alt="text icon"
                  entitiesCount={entitiesCount}
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <ContentModel
                    contentModelId={field.field_addition.id}
                    setEntitiesCount={setEntitiesCount}
                  />
                </FieldElement>
              );
            case 'Select':
              return (
                <FieldElement
                  key={index}
                  alt="text icon"
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <SelecteElement
                    field_addition={field.field_addition ? field.field_addition : {}}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || []}
                  />
                </FieldElement>
              );
            default:
              return <p key={index}>{field_type}</p>;
          }
        })}
      </Col>
    </Row>
  );
};

const ContentDetailBody = ({ contentDraft, setContentDraft }) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedField, setSelectedField] = useState('');
  const [selectedLang, setSelectedLang] = useState('en');
  const [isImage, setIsImage] = useState(true);

  const toggleModal = () => {
    setModalVisible((prevState) => !prevState);
  };

  const onFieldClick = (name, lang, isImage) => {
    return () => {
      setSelectedField(name);
      setSelectedLang(lang);
      setIsImage(isImage);
      toggleModal();
    };
  };

  const onModalOk = ({ url }) => {
    onGenericChange(selectedField, selectedLang)(url);
    toggleModal();
  };

  const onGenericChange = (key, lang) => {
    return (value) => {
      setContentDraft({
        ...contentDraft,
        data: {
          ...contentDraft.data,
          [lang]: {
            ...contentDraft.data[lang],
            [key]: value
          }
        }
      });
    };
  };

  const activeLanguages = useSelector(({ language }) => language.activeLanguages);

  return (
    <div
      style={{
        background: 'white',
        margin: '0px',
        paddingBottom: '64px'
      }}
    >
      <Tabs defaultActiveKey="0">
        {activeLanguages.map(({ name, key }, index) => (
          <TabPane key={index} tab={<div className="custom-tabs">{name}</div>}>
            <ContentDetailForm
              content={contentDraft}
              lang={key}
              onGenericChange={onGenericChange}
              onSelectExisting={onFieldClick}
            />
          </TabPane>
        ))}
      </Tabs>
      <SelectExisting
        isImages={isImage}
        onCancel={toggleModal}
        onOk={onModalOk}
        visible={modalVisible}
      />
    </div>
  );
};

export default ContentDetailBody;
